type CustomerLabelSource = {
  socialName?: string | null;
  name?: string | null;
};

export function resolveCustomerLegalName(customer: CustomerLabelSource): string {
  return String(customer.socialName ?? customer.name ?? '').trim();
}

/** Rótulo do accordion de estipulante/subestipulante nos resumos de cotação/proposta/análise. */
export function buildStipulantAccordionLabel(
  sequenceNumber: number,
  customer: CustomerLabelSource,
): string {
  const base =
    sequenceNumber === 0 ? 'Estipulante' : `Subestipulante ${sequenceNumber}`;

  if (sequenceNumber === 0) return base;

  const legalName = resolveCustomerLegalName(customer);
  return legalName ? `${base} — ${legalName}` : base;
}
